import { graphql } from '@apollo/client/react/hoc';
import { TextBox, Theme as theme } from '@spoiler-alert/ui-library';
import accounting from 'accounting';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { createNegotiationStagedListings } from '../../graphql/mutations';

// This component is a text box on the negotiation page that allows you to manually update unit price.

const styles = {
  price_field: {
    display: 'flex',
    width: 100,
    margin: [-7, 'auto', -10],
  },
  price__input: {
    width: '73px !important',
    textAlign: 'right !important',
    paddingRight: '8px !important',
  },
  price__input_wrap: {
    width: 75,
  },
  price__dollar: {
    lineHeight: '34px',
    paddingRight: 3,
  },
  price__textbox: {
    height: '34px !important',
  },
  price__textbox_saved: {
    borderColor: `${theme.primaryColor} !important`,
  },
  price__textbox_failure: {
    borderColor: `${theme.downArrowColor} !important`,
  },
};

class NegotiationTextbox extends Component {
  static propTypes = {
    onFailure: PropTypes.func,
    createNegotiationStagedListings: PropTypes.func,
    row: PropTypes.object,
    classes: PropTypes.object,
    refetchQueries: PropTypes.array,
  };

  state = {
    status: undefined,
    value: accounting.formatMoney(this.props.row.negotiationListing.suggestedUnitPrice, ''),
  };

  componentDidUpdate(prevProps) {
    const newValue = this.props.row.negotiationListing.suggestedUnitPrice;
    if (prevProps.row.negotiationListing.suggestedUnitPrice !== newValue) {
      this.setState({
        value: accounting.formatMoney(newValue, ''),
      });
    }
  }

  savePrice = (row, value) => {
    const { onFailure, refetchQueries } = this.props;
    const price = accounting.unformat(value);
    if (price <= 0) {
      this.setState({
        status: 'failure',
        value: accounting.formatMoney(this.props.row.negotiationListing.suggestedUnitPrice, ''),
      });
      return;
    }
    const variables = {
      counterOffers: {
        offerListingId: row.offerListing._id,
        counterOfferQuantity: row.negotiationListing.suggestedQuantity,
        counterOfferPrice: price,
        counterOfferAnchor: 'FlatRate',
        reason: row.negotiationListing.reason || '',
      },
    };
    this.props
      .createNegotiationStagedListings({ variables, refetchQueries })
      .then((response) => {
        const result = response.data.createNegotiationStagedListings;
        if (result.errors?.length > 0) {
          const message =
            result.errors[0].code === 'NEGOTIATION_PUBLISHED' ? result.errors[0].message : 'A problem occurred while saving the listing price.';
          throw new Error(message);
        }
        this.setState({ status: 'success', value: accounting.formatMoney(value, '') });
        setTimeout(this.clearSavedStatus.bind(this, row._id), 5000);
      })
      .catch((err) => {
        this.setState({ status: 'failure' });
        onFailure(err.message);
      });
  };

  clearSavedStatus = () => {
    this.setState({ status: undefined });
  };

  updateValue = (value) => {
    this.setState({ value });
  };

  render() {
    const { classes, row } = this.props;
    const { status, value } = this.state;
    let textboxClass = '';
    if (status === 'success') textboxClass = classes.price__textbox_saved;
    if (status === 'failure') textboxClass = classes.price__textbox_failure;
    return (
      <div className={classes.price_field} onClick={(e) => e.stopPropagation()}>
        <span className={classes.price__dollar}>$</span>
        <div className={classes.price__input_wrap}>
          <TextBox
            type="text"
            className={`${classes.price__textbox} ${textboxClass}`}
            onChange={this.updateValue}
            onBlur={this.savePrice.bind(this, row)}
            inputClassName={classes.price__input}
            labelSROnly
            labelText="Number Input"
            value={value}
          />
        </div>
      </div>
    );
  }
}

const DecoratedNegotiationTextbox = graphql(createNegotiationStagedListings, { name: 'createNegotiationStagedListings' })(
  injectSheet(styles)(NegotiationTextbox),
);

export { DecoratedNegotiationTextbox as NegotiationTextbox };
export default DecoratedNegotiationTextbox;
